// removed by extract-text-webpack-plugin
module.exports = {"header":"_14cfrjMNSIdz_DTREvlA59"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Breadcrumbs.less
// module id = 381
// module chunks = 0